(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 1151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ruta/[slug]",
      function () {
        return __webpack_require__(1820);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ getFollowSchools; },
/* harmony export */   "Dl": function() { return /* binding */ getPlacementTest; },
/* harmony export */   "Lx": function() { return /* binding */ getRoutesProgress; },
/* harmony export */   "iC": function() { return /* binding */ followSchool; },
/* harmony export */   "it": function() { return /* binding */ saveEmail; },
/* harmony export */   "mt": function() { return /* binding */ unFollowSchool; },
/* harmony export */   "uA": function() { return /* binding */ getRouteProgress; }
/* harmony export */ });
/* unused harmony exports getHeader, getIdentity, getExplore, getContactInfo, getPriceTable, getSchool, getCommunityInfo, getRoute, getUserPlans, getB2bPlans */
/* harmony import */ var _platzi_commons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3099);
/* harmony import */ var src_env__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3223);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6394);



var getHeader = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.header);
};
var getIdentity = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.identity);
};
var getExplore = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.explore);
};
var getContactInfo = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.server.contactInfo);
};
var getPriceTable = function(headers) {
    return http.axiosServerInstance(headers).get(schoolsApi.client.tablePrice);
};
var getSchool = function(slug) {
    return http.axiosInstance().get(API_URL + schoolsApi.server.school(slug));
};
var getCommunityInfo = function(slug) {
    return http.axiosInstance().get(API_URL + schoolsApi.server.community(slug));
};
var getRoute = function(slug) {
    return http.axiosInstance().get(API_URL + schoolsApi.server.route(slug));
};
var getFollowSchools = function() {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.getFollowSchools */ .b.client.schools.getFollowSchools);
};
var followSchool = function(schoolId, payload) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).post(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.followSchool */ .b.client.schools.followSchool(schoolId), payload);
};
var unFollowSchool = function(schoolId) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).delete(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.unFollowSchool */ .b.client.schools.unFollowSchool(schoolId));
};
var getPlacementTest = function(schoolSlug) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.placement_test */ .b.client.schools.placement_test(schoolSlug));
};
var getRoutesProgress = function(schoolSlug) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance(true).get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.schools.routesProgress */ .b.client.schools.routesProgress(schoolSlug));
};
var saveEmail = function(payload) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance().post(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.registerEmail */ .b.client.registerEmail, payload);
};
var getUserPlans = function() {
    return http.axiosInstance().get(schoolsApi.client.userPlans);
};
var getB2bPlans = function() {
    return http.axiosInstance().get(schoolsApi.client.b2bPlans);
};
var getRouteProgress = function(id) {
    return _platzi_commons__WEBPACK_IMPORTED_MODULE_2__.a.axiosInstance().get(_services_api__WEBPACK_IMPORTED_MODULE_1__/* .schoolsApi.client.routes.routeProgress */ .b.client.routes.routeProgress(id));
};


/***/ }),

/***/ 8214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ PricingTable; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(6064);
// EXTERNAL MODULE: ./node_modules/@platzi/micro-ui.plans/dist/es/index.js + 7 modules
var dist_es = __webpack_require__(228);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faUserAstronaut.js
var faUserAstronaut = __webpack_require__(187);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faRocket.js
var faRocket = __webpack_require__(8308);
;// CONCATENATED MODULE: ./src/components/shared/PricingTable/utils/constants.ts


var USER_TYPE = "personal";
var B2B_TYPE = "empresas";
var COOKIE_TAB = "price-tab";
var tabsData = [
    {
        id: 1,
        text: USER_TYPE,
        icon: faUserAstronaut/* faUserAstronaut */.KC
    },
    {
        id: 2,
        text: B2B_TYPE,
        icon: faRocket/* faRocket */.tM
    }, 
];

// EXTERNAL MODULE: ./src/components/shared/PricingTable/PricingTable.module.sass
var PricingTable_module = __webpack_require__(5795);
var PricingTable_module_default = /*#__PURE__*/__webpack_require__.n(PricingTable_module);
;// CONCATENATED MODULE: ./src/components/shared/PricingTable/PricingTable.tsx






var PricingTable = function() {
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header").get("isLogged");
    });
    var user = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("userInfo");
    }, es/* shallowEqual */.wU).toJS();
    var paywalls = (0,es/* useSelector */.v9)(function(state) {
        return state.get("plans");
    }, es/* shallowEqual */.wU).toJS();
    var isFree = (user === null || user === void 0 ? void 0 : user.userType) === "free";
    var userType = USER_TYPE;
    var onClickPlan = function(plan) {
        window.location.href = (plan === null || plan === void 0 ? void 0 : plan.buy_url) || "/comprar/".concat(plan === null || plan === void 0 ? void 0 : plan.slug);
    };
    var messages = {
        title: "Suscr\xedbete y potencia tu futuro profesional",
        subtitle: "Contenido profesional y actualizado con certificados digitales.",
        disclaimer: "Nunca subiremos el precio si mantienes tu suscripci\xf3n activa"
    };
    var showDisclaimer = (paywalls === null || paywalls === void 0 ? void 0 : paywalls.country_code) !== "AR";
    if (!Object.keys(paywalls).length) return null;
    if (isLogged && !isFree) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (PricingTable_module_default()).PricingTable,
        id: "planes",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "u-wrapper",
            children: userType === USER_TYPE && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* PlansTable */.vZ, {
                plans: paywalls,
                showB2BLink: true,
                showDisclaimer: showDisclaimer,
                showBanner: true,
                onClickPlan: onClickPlan,
                messages: messages
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/shared/PricingTable/index.ts



/***/ }),

/***/ 5065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ShareButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(2814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.es.js
var pro_regular_svg_icons_index_es = __webpack_require__(2825);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/index-097a0a02.js + 1 modules
var index_097a0a02 = __webpack_require__(8888);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Button-d3fb7b8f.js
var Button_d3fb7b8f = __webpack_require__(7373);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__(1417);
;// CONCATENATED MODULE: ./src/components/shared/Share/socialNetwork.ts

var socialNetwork = function(url, title) {
    var routeOrSchool = (url === null || url === void 0 ? void 0 : url.includes("ruta")) ? "Ruta" : "Escuela";
    var whatsappCopy = (url === null || url === void 0 ? void 0 : url.includes("ruta")) ? "https://api.whatsapp.com/send/?text=Te%20comparto%20esta%20Ruta%20de%20Aprendizaje%20para%20que%20tomes%20las%20primeras%20clases%20sin%20costo: ".concat(url) : "https://api.whatsapp.com/send/?text=Te%20comparto%20esta%20Escuela%20de%20".concat(title, "%20para%20que%20tomes%20las%20primeras%20clases%20sin%20costo: ").concat(url);
    return [
        {
            network: "whatsapp",
            url: whatsappCopy,
            icon: free_brands_svg_icons_index_es/* faWhatsapp */.VHX,
            class: "whatsapp"
        },
        {
            network: "twitter",
            url: "https://twitter.com/intent/tweet/?text=Inici%C3%A9%20la%20".concat(routeOrSchool, "%20de%20").concat(title, "%20en%20@platzi%20%F0%9F%92%9A%20Suscr%C3%ADbete%20y%20s%C3%A9%20parte%20de%20la%20comunidad%20de%20aprendizaje%20m%C3%A1s%20grande%20de%20Latinoam%C3%A9rica.%20").concat(url),
            icon: free_brands_svg_icons_index_es/* faTwitter */.mdU,
            class: "twitter"
        },
        {
            network: "telegram",
            url: "https://telegram.me/share/url?text=%C2%A1Mira!%20Encontr%C3%A9%20la%20".concat(routeOrSchool, "%20de%20").concat(title, "%20en%20Platzi%20%C2%BFy%20si%20la%20empezamos%20y%20aprendemos%20en%20comunidad?%20").concat(url),
            icon: free_brands_svg_icons_index_es/* faTelegramPlane */.IKq,
            class: "telegram"
        },
        {
            network: "facebook",
            url: "https://www.facebook.com/sharer/sharer.php?u=".concat(url),
            icon: free_brands_svg_icons_index_es/* faFacebookF */.AYu,
            class: "facebook"
        },
        {
            network: "linkedin",
            url: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(url),
            icon: free_brands_svg_icons_index_es/* faLinkedinIn */.hwn,
            class: "linkedin"
        }, 
    ];
};

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/ModalPortal-617887ea.js
var ModalPortal_617887ea = __webpack_require__(6927);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-4abe4715.js
var index_4abe4715 = __webpack_require__(4230);
// EXTERNAL MODULE: ./src/components/shared/Share/ShareModal.module.sass
var ShareModal_module = __webpack_require__(7601);
var ShareModal_module_default = /*#__PURE__*/__webpack_require__.n(ShareModal_module);
;// CONCATENATED MODULE: ./src/components/shared/Share/ShareModal.tsx








var eventsSentSocialMedia = [];
var ShareModal = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(props.pathToShare), inputValue = ref[0], setInputValue = ref[1];
    var TIME_TO_FEEDBACK_USER = 1000;
    if (!props.showModal || !props.socialNetwork) return null;
    var handleCopyUrl = function() {
        var currentURl = props.pathToShare;
        navigator.clipboard.writeText(currentURl);
        setInputValue(t("escuela.share.copied"));
        setTimeout(function() {
            setInputValue(currentURl);
        }, TIME_TO_FEEDBACK_USER);
    };
    var handleSocialMediaClick = function(item) {
        return function() {
            if (props.recordSocialMediaClick && !eventsSentSocialMedia.includes(item.network)) {
                index_097a0a02.q.send({
                    event: props.recordSocialMediaClick.event,
                    route_slug: props.recordSocialMediaClick.route_name,
                    network_name: item.network
                });
                eventsSentSocialMedia.push(item.network);
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPortal_617887ea.M, {
        show: props.showModal,
        close: function() {
            return props.handleShowModal(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_4abe4715.C, {
            isDark: true,
            customClass: (ShareModal_module_default()).Card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (ShareModal_module_default()).CloseModal,
                    type: "button",
                    onClick: function() {
                        return props.handleShowModal(false);
                    },
                    "aria-label": t("escuela.share.buttonCloseModal"),
                    "data-testid": "modal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_regular_svg_icons_index_es/* faTimes */.NBC,
                        size: "sm"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: props.sharedCopy
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: props.socialNetwork.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (ShareModal_module_default())[item.class],
                                        onClick: handleSocialMediaClick(item),
                                        href: item.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": t("escuela.share.socialNetwork", {
                                            network: item.network
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: item.icon,
                                            size: "lg"
                                        })
                                    })
                                }, "network-".concat(index));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ShareModal_module_default()).Input,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    value: inputValue ? inputValue : props.pathToShare,
                                    readOnly: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: handleCopyUrl,
                                    "aria-label": t("escuela.share.copyUrl"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_regular_svg_icons_index_es/* faCopy */.kZ_
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/shared/Share/ShareButton.module.sass
var ShareButton_module = __webpack_require__(5853);
var ShareButton_module_default = /*#__PURE__*/__webpack_require__.n(ShareButton_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/shared/Share/ShareButton.tsx











var clickEventSent = false;
var ShareButton = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), showShareModal = ref3[0], setShowShareModal = ref3[1];
    var ref4 = (0,react.useState)(""), pathToShare = ref4[0], setPathToShare = ref4[1];
    (0,react.useEffect)(function() {
        setPathToShare(window.location.href);
    }, []);
    var handleClick = function() {
        if (props.recordClickEvent && !clickEventSent) {
            index_097a0a02.q.send((0,_object_spread/* default */.Z)({}, props.recordClickEvent));
            clickEventSent = true;
        }
        setShowShareModal(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_d3fb7b8f.B, {
                as: "button",
                color: "sky",
                hierarchy: "tertiary",
                customClass: classnames_default()((ShareButton_module_default()).Button, props.customClass),
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_regular_svg_icons_index_es/* faShareNodes */.M6U
                    }),
                    props.isLogged ? (ref = props.messages) === null || ref === void 0 ? void 0 : ref.isLogged : (ref1 = props.messages) === null || ref1 === void 0 ? void 0 : ref1.notLogged
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal, {
                socialNetwork: socialNetwork(pathToShare, props.socialNetworkTitle),
                showModal: showShareModal,
                handleShowModal: setShowShareModal,
                pathToShare: pathToShare,
                sharedCopy: (ref2 = props.messages) === null || ref2 === void 0 ? void 0 : ref2.sharedCopy,
                recordSocialMediaClick: props.recordSocialMediaClick
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/shared/Share/index.ts



/***/ }),

/***/ 1820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(6064);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/ModalPortal-617887ea.js
var ModalPortal_617887ea = __webpack_require__(6927);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/useQueryParam-7b678fd6.js
var useQueryParam_7b678fd6 = __webpack_require__(9998);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/constants.js
var constants = __webpack_require__(160);
// EXTERNAL MODULE: ./src/redux/actions/actionTypes.ts
var actionTypes = __webpack_require__(8161);
;// CONCATENATED MODULE: ./src/redux/actions/index.ts

var updateNextMaterial = function(payload) {
    return {
        type: actionTypes/* actionTypes.UPDATE_NEXT_MATERIAL */.H.UPDATE_NEXT_MATERIAL,
        payload: payload
    };
};
var createOrganizerLink = function(payload) {
    return {
        type: actionTypes/* actionTypes.CREATE_ORGANIZER_LINK */.H.CREATE_ORGANIZER_LINK,
        payload: payload
    };
};
var updateCourseProgress = function(payload) {
    return {
        type: actionTypes/* actionTypes.UPDATE_COURSE_PROGRESS */.H.UPDATE_COURSE_PROGRESS,
        payload: payload
    };
};

// EXTERNAL MODULE: ./src/api/index.ts
var api = __webpack_require__(4196);
// EXTERNAL MODULE: ./src/components/shared/PricingTable/index.ts + 2 modules
var PricingTable = __webpack_require__(8214);
// EXTERNAL MODULE: ./src/components/routes/Layout/Layout.module.sass
var Layout_module = __webpack_require__(8303);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./src/components/routes/Layout/Layout.tsx










var Layout = function() {
    var routeId = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("id");
    }) || 0;
    var ref = (0,react.useState)(false), isMobile = ref[0], setIsMobile = ref[1];
    var ref1 = (0,useQueryParam_7b678fd6.a)(), screenWidth = ref1.width;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        screenWidth < constants/* SM_BREAKPOINT */.Zb ? setIsMobile(true) : setIsMobile(false);
    }, [
        screenWidth
    ]);
    (0,react.useEffect)(function() {
        if (routeId === 0) return;
        (0,api/* getRouteProgress */.uA)(routeId).then(function(param) {
            var data = param.data;
            dispatch(updateNextMaterial(data.data.actual_organization_course));
            dispatch(updateCourseProgress(data.data.course_progress));
            dispatch(createOrganizerLink(data.data.edit_url));
        }).catch(function(err) {
            throw new Error("::ERROR::ROUTES__LAYOUT", {
                cause: err
            });
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalPortal_617887ea.B, {
        isDark: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Layout_module_default()).Layout,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "u-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Layout_module_default()).Columns,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
                                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside_Aside, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {})
                                ]
                            }),
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside_Aside, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingTable/* PricingTable */.b, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/routes/Top/Top.tsx




var Top = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: styles.Top,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "".concat(styles.ContentTop, " u-wrapper"),
            children: [
                /*#__PURE__*/ _jsx(Header, {}),
                /*#__PURE__*/ _jsx(Aside, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var es_useTranslation = __webpack_require__(7058);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(2814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var pro_solid_svg_icons_index_es = __webpack_require__(2565);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Button-d3fb7b8f.js
var Button_d3fb7b8f = __webpack_require__(7373);
// EXTERNAL MODULE: ./node_modules/@platzi/commons/dist/es/index-097a0a02.js + 1 modules
var index_097a0a02 = __webpack_require__(8888);
// EXTERNAL MODULE: ./src/components/shared/Share/index.ts + 3 modules
var Share = __webpack_require__(5065);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.es.js
var pro_regular_svg_icons_index_es = __webpack_require__(2825);
// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/index-4abe4715.js
var index_4abe4715 = __webpack_require__(4230);
// EXTERNAL MODULE: ./src/components/routes/Header/ModalUnfollow.module.sass
var ModalUnfollow_module = __webpack_require__(620);
var ModalUnfollow_module_default = /*#__PURE__*/__webpack_require__.n(ModalUnfollow_module);
;// CONCATENATED MODULE: ./src/components/routes/Header/ModalUnfollow.tsx










var ModalUnfollow = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var learningPathId = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("id");
    }) || 0;
    var ref = (0,react.useState)(), userSchoolId = ref[0], setUserSchoolId = ref[1];
    (0,react.useEffect)(function() {
        (0,api/* getFollowSchools */.CS)().then(function(res) {
            var ref, ref1;
            var followedLearningPathId = (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                return item.learningPathId === learningPathId;
            });
            setUserSchoolId(followedLearningPathId === null || followedLearningPathId === void 0 ? void 0 : (ref1 = followedLearningPathId[0]) === null || ref1 === void 0 ? void 0 : ref1.id);
        }).catch(function(err) {
            throw new Error("::ERROR::GET_FOLLOW_SCHOOLS", {
                cause: err
            });
        });
    }, []);
    var handleUnfollowRoute = function() {
        if (!userSchoolId) {
            (0,api/* getFollowSchools */.CS)().then(function(res) {
                var ref, ref1;
                var followedLearningPathId = (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                    return item.learningPathId === learningPathId;
                });
                (0,api/* unFollowSchool */.mt)(followedLearningPathId === null || followedLearningPathId === void 0 ? void 0 : (ref1 = followedLearningPathId[0]) === null || ref1 === void 0 ? void 0 : ref1.id);
                props.setUserFollowSchool(false);
                props.setShowModal(false);
            }).catch(function(err) {
                throw new Error("::ERROR::GET_FOLLOW_SCHOOLS", {
                    cause: err
                });
            });
        } else {
            (0,api/* unFollowSchool */.mt)(userSchoolId).then(function() {
                props.setUserFollowSchool(false);
                props.setShowModal(false);
            }).catch(function(err) {
                throw new Error("::ERROR::FOLLOW_ROUTES_ADD-ROUTE-BUTTON", {
                    cause: err
                });
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalPortal_617887ea.M, {
        show: props.showModal,
        close: props.closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_4abe4715.C, {
                customClass: (ModalUnfollow_module_default()).Card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (ModalUnfollow_module_default()).CloseModal,
                        type: "button",
                        onClick: function() {
                            return props.setShowModal(false);
                        },
                        "data-testid": "modal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons_index_es/* faTimes */.NBC,
                            size: "sm"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ModalUnfollow_module_default()).CardHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_regular_svg_icons_index_es/* faCircleMinus */.W7v
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("route.modalUnfollow.title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ModalUnfollow_module_default()).CardBody,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("route.modalUnfollow.description")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ModalUnfollow_module_default()).CardFooter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_d3fb7b8f.B, {
                        customClass: (ModalUnfollow_module_default()).CancelButton,
                        onClick: function() {
                            return props.setShowModal(false);
                        },
                        children: t("route.modalUnfollow.cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_d3fb7b8f.B, {
                        onClick: handleUnfollowRoute,
                        children: t("route.modalUnfollow.accept")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Header_ModalUnfollow = (ModalUnfollow);

// EXTERNAL MODULE: ./src/components/routes/Header/Actions.module.sass
var Actions_module = __webpack_require__(1258);
var Actions_module_default = /*#__PURE__*/__webpack_require__.n(Actions_module);
;// CONCATENATED MODULE: ./src/components/routes/Header/Actions.tsx













var Actions = function(props) {
    var nextClass = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("material_data").get("material_url");
    }) || "";
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var slug = router.query.slug;
    var ref = (0,react.useState)(undefined), userFollowSchool = ref[0], setUserFollowSchool = ref[1];
    var ref1 = (0,react.useState)(false), showModal = ref1[0], setShowModal = ref1[1];
    var recordFollowRoute = {
        event: "route_follow_route",
        route_name: slug
    };
    var recordClickData = {
        event: "route_share_button",
        route_name: slug
    };
    var recordSocialMediaClickData = {
        event: "route_share_network",
        route_name: slug
    };
    var onStartRouteClick = function() {
        index_097a0a02.q.send({
            event: "route_start_route",
            route_name: slug
        });
        window.location.replace(nextClass);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Actions_module_default()).Actions,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_d3fb7b8f.B, {
                customClass: (Actions_module_default()).StartCta,
                onClick: onStartRouteClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons_index_es/* faPlay */.zc
                    }),
                    t("route.actions.startRoute")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddRouteButton, {
                recordFollowRoute: recordFollowRoute,
                setShowModal: setShowModal,
                userFollowSchool: userFollowSchool,
                setUserFollowSchool: setUserFollowSchool
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* ShareButton */.T, {
                isLogged: true,
                customClass: (Actions_module_default()).ShareCta,
                recordClickEvent: recordClickData,
                recordSocialMediaClick: recordSocialMediaClickData,
                messages: {
                    isLogged: t("route.actions.share"),
                    notLogged: t("route.actions.share"),
                    sharedCopy: t("route.actions.sharedCopy")
                },
                socialNetworkTitle: props.socialNetworkTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ModalUnfollow, {
                showModal: showModal,
                setShowModal: setShowModal,
                setUserFollowSchool: setUserFollowSchool
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/routes/Header/AdminButton.module.sass
var AdminButton_module = __webpack_require__(7494);
var AdminButton_module_default = /*#__PURE__*/__webpack_require__.n(AdminButton_module);
;// CONCATENATED MODULE: ./src/components/routes/Header/AdminButton.tsx





var AdminButton = function() {
    var isOrganizer = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("contactInfo")) === null || ref === void 0 ? void 0 : ref.get("isOrganizer");
    }) || false;
    var editUrl = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.get("route")) === null || ref === void 0 ? void 0 : ref.get("edit_url");
    }) || "";
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    if (!isOrganizer) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AdminButton_module_default()).AdminButton,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: editUrl,
            children: t("route.adminButton.cta")
        })
    });
};

// EXTERNAL MODULE: ./src/components/routes/Header/Header.module.sass
var Header_module = __webpack_require__(4265);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./src/components/routes/Header/Header.tsx









var Header_Header = function() {
    var ref;
    var headerInfo = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("hero");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var isLogged = (0,es/* useSelector */.v9)(function(state) {
        return state.get("header");
    }).get("isLogged") || false;
    var isProfessional = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("is_professional");
    }) || false;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Header_module_default()).Header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Header_module_default()).Title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            t("route.header.label"),
                            isProfessional && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons_index_es/* faBadgeCheck */.fix
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: headerInfo.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: headerInfo.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    isLogged ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {
                        socialNetworkTitle: headerInfo.title
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/precios/",
                        className: (Header_module_default()).BuyButton,
                        "data-trans": "route.selectPlan.buyText",
                        children: t("route.selectPlan.buyText")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminButton, {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/Image-7064ed9b.js
var Image_7064ed9b = __webpack_require__(7589);
// EXTERNAL MODULE: ./src/components/routes/Aside/Aside.module.sass
var Aside_module = __webpack_require__(2705);
var Aside_module_default = /*#__PURE__*/__webpack_require__.n(Aside_module);
;// CONCATENATED MODULE: ./src/components/routes/Aside/Aside.tsx









var Aside_Aside = function() {
    var ref, ref1;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref2 = (0,useQueryParam_7b678fd6.a)(), screenWidth = ref2.width;
    var material = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("material_data");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var teachers = ((ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("teachers");
    })) === null || ref1 === void 0 ? void 0 : ref1.toJS()) || [];
    var totalCourses = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("total_courses");
    }) || 0;
    var totalHoursContent = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("total_hours_of_content");
    }) || 0;
    var ref3 = (0,react.useState)(true), isMobile = ref3[0], setIsMobile = ref3[1];
    var ref4 = (0,react.useState)(false), showAllTeachers = ref4[0], setShowAllTeachers = ref4[1];
    (0,react.useEffect)(function() {
        screenWidth < constants/* MD_BREAKPOINT */.qY ? setIsMobile(true) : setIsMobile(false);
    }, [
        screenWidth
    ]);
    var handleShowAllTeachers = function() {
        setShowAllTeachers(!showAllTeachers);
    };
    var showAllTeachersList = showAllTeachers && !isMobile ? teachers.length : 3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Aside_module_default()).Aside,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Aside_module_default()).Content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (Aside_module_default()).Thumbnail,
                        href: material.material_url,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_7064ed9b.I, {
                                src: material.thumbnail,
                                alt: material.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons_index_es/* faPlay */.zc
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Aside_module_default()).ClassContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (Aside_module_default()).ClassTitle,
                                children: material.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Aside_module_default()).Course,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_7064ed9b.I, {
                                        src: material.badge_url,
                                        alt: material.course_title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: material.course_title
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Aside_module_default()).RouteContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons_index_es/* faBook */.FL8
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        totalCourses,
                                        " ",
                                        t("route.aside.coursesInfoText")
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Aside_module_default()).TeachersContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Aside_module_default()).TeachersContentHeader,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Aside_module_default()).Title,
                                        children: t("route.aside.teachersTitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (Aside_module_default()).ShowMore,
                                        onClick: handleShowAllTeachers,
                                        children: showAllTeachers ? t("route.aside.seeLess") : t("route.aside.seeMore")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: teachers === null || teachers === void 0 ? void 0 : teachers.slice(0, showAllTeachersList).map(function(teacher, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: teacher.profile_url,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_7064ed9b.I, {
                                                    src: teacher.avatar,
                                                    alt: teacher.name
                                                }),
                                                teacher.name
                                            ]
                                        })
                                    }, "teacher-".concat(index));
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Aside_module_default()).ModalContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalPortal_617887ea.M, {
                    show: showAllTeachers && isMobile,
                    close: handleShowAllTeachers,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Aside_module_default()).TeachersHeaderModal,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("route.aside.teachersTitle")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons_index_es/* faClose */.YIN,
                                    className: (Aside_module_default()).TeachersHeaderModalClose,
                                    onClick: handleShowAllTeachers
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Aside_module_default()).TeachersContentModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: teachers.map(function(teacher, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: teacher.profile_url,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_7064ed9b.I, {
                                                    src: teacher.avatar,
                                                    alt: teacher.name
                                                }),
                                                teacher.name
                                            ]
                                        })
                                    }, "teacher-".concat(index));
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/routes/StartInPlatziForm/StartInPlatziForm.tsx








var StartInPlatziForm = function() {
    var ref;
    var material = ((ref = useSelector(function(state) {
        return state.get("route").get("material_data");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || {};
    var ref1 = useState(""), error = ref1[0], setError = ref1[1];
    var ref2 = useState(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var t = useTranslation().t;
    var handleOnSubmit = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (isLoading) return;
        var value = event.target.email.value;
        if (value.trim() <= 0 || !emailRegex.test(value.toLowerCase().trim())) {
            return setError(t("route.startInPlatziForm.error"));
        } else {
            setIsLoading(true);
            var formData = new FormData();
            formData.append("email", value);
            formData.append("origin", "routes");
            formData.append("full_path", window.location.href);
            var onboardingUrl = "/onboarding/?next=".concat(material === null || material === void 0 ? void 0 : material.material_url, "&email=").concat(value);
            saveEmail(formData).then(function() {
                return window.location.href = onboardingUrl;
            }).catch(function(err) {
                throw new Error("::ERROR::ROUTES__START_IN_PLATZI_FORM", {
                    cause: err
                });
            });
        }
    };
    return /*#__PURE__*/ _jsxs("form", {
        className: styles.Form,
        onSubmit: handleOnSubmit,
        children: [
            /*#__PURE__*/ _jsx("label", {
                htmlFor: "email",
                children: t("route.startInPlatziForm.label")
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.FormPosition,
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        name: "email",
                        placeholder: t("route.startInPlatziForm.email"),
                        behavior: error ? "error" : "default",
                        message: error,
                        customClass: styles.Input
                    }),
                    /*#__PURE__*/ _jsxs(Button, {
                        as: "button",
                        type: "submit",
                        color: "platzi",
                        children: [
                            t("route.startInPlatziForm.startNow"),
                            isLoading && /*#__PURE__*/ _jsx(Loader, {
                                customStyle: styles.loader
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: styles.Terms,
                children: [
                    t("route.startInPlatziForm.termsTextInitial"),
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        target: "blank",
                        href: "https://platzi.com/terminos/",
                        children: t("route.startInPlatziForm.termsTextTerms")
                    }),
                    " ",
                    t("route.startInPlatziForm.and"),
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        target: "blank",
                        href: "https://platzi.com/privacidad/",
                        children: t("route.startInPlatziForm.termsTextPolitics")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./src/components/routes/Steps/Course.module.sass
var Course_module = __webpack_require__(278);
var Course_module_default = /*#__PURE__*/__webpack_require__.n(Course_module);
;// CONCATENATED MODULE: ./src/components/routes/Steps/Course.tsx







var Course = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (Course_module_default()).Course,
        href: props.url,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Course_module_default()).CourseInformation,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_7064ed9b.I, {
                        src: props.badge_url,
                        alt: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    props.content_duration,
                                    " ",
                                    t("route.course.contentHours"),
                                    " ",
                                    props.practice_duration,
                                    " ",
                                    t("route.course.practiceHours")
                                ]
                            })
                        ]
                    })
                ]
            }),
            props.is_approved && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Course_module_default()).CourseProgressCont,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons_index_es/* faBadgeCheck */.fix
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("route.course.approved")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/routes/Steps/Module.module.sass
var Module_module = __webpack_require__(2034);
var Module_module_default = /*#__PURE__*/__webpack_require__.n(Module_module);
;// CONCATENATED MODULE: ./src/components/routes/Steps/Module.tsx





var Module = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Module_module_default()).Module,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Module_module_default()).TitleContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (Module_module_default()).Title,
                    children: props.title
                })
            }),
            props.courses.map(function(course, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Course, (0,_object_spread/* default */.Z)({}, course), "Course-".concat(index));
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/routes/Steps/Steps.module.sass
var Steps_module = __webpack_require__(3471);
var Steps_module_default = /*#__PURE__*/__webpack_require__.n(Steps_module);
;// CONCATENATED MODULE: ./src/components/routes/Steps/Steps.tsx






var Steps = function() {
    var ref;
    var steps = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("steps");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Steps_module_default()).Steps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((Steps_module_default()).Modules),
            children: steps.map(function(step, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Module, (0,_object_spread/* default */.Z)({}, step), "Module-".concat(index));
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/routes/Banner/Banner.tsx








var Banner = function(props) {
    var t = useTranslation().t;
    var isLogged = useSelector(function(state) {
        return state.get("header");
    }).get("isLogged") || false;
    var ref = useState(false), show = ref[0], setShow = ref[1];
    useEffect(function() {
        var showBannerLocalStorage = localStorage.getItem(props.id);
        if (showBannerLocalStorage === "false") {
            setShow(false);
        } else {
            setShow(true);
        }
    }, [
        props.id
    ]);
    var handleCloseBanner = function() {
        localStorage.setItem(props.id, "false");
        setShow(false);
    };
    if (!show) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "".concat(styles.Container, " ").concat(props.id === "whatIsPlatziBanner" && styles.ContainerBackgroundImage),
        children: [
            isLogged && /*#__PURE__*/ _jsx("div", {
                className: styles.CloseButtonCont,
                onClick: handleCloseBanner,
                children: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                    icon: faClose
                })
            }),
            /*#__PURE__*/ _jsx(Image, {
                src: props.image,
                alt: t(props.title),
                customClass: styles.Image
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.Content,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.Title,
                        children: t(props.title)
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.Description,
                        children: t(props.description)
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./src/components/routes/Post/Post.module.sass
var Post_module = __webpack_require__(2011);
var Post_module_default = /*#__PURE__*/__webpack_require__.n(Post_module);
;// CONCATENATED MODULE: ./src/components/routes/Post/Post.tsx







var Post = function() {
    var ref;
    var postInfo = ((ref = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("post");
    })) === null || ref === void 0 ? void 0 : ref.toJS()) || [];
    var ref1 = (0,react.useState)([]), items = ref1[0], setItems = ref1[1];
    var ref2 = (0,react.useState)([]), itemsOpen = ref2[0], setItemsOpen = ref2[1];
    (0,react.useEffect)(function() {
        var content = [];
        var contentOpen = [];
        postInfo.forEach(function(post, i) {
            contentOpen.push(i);
            content.push({
                title: post.title,
                content: post.text,
                id: i
            });
        });
        setItems(content);
        setItemsOpen(contentOpen);
    }, []);
    var handleOpen = function(id) {
        return function() {
            var idParsed = Number(id);
            if (itemsOpen.includes(idParsed)) {
                return setItemsOpen(itemsOpen.filter(function(item) {
                    return item !== idParsed;
                }));
            }
            setItemsOpen(_toConsumableArray(itemsOpen).concat([
                idParsed
            ]));
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Post_module_default()).Post,
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            var isOpen = itemsOpen.includes(item.id);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Post_module_default()).Accordion,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: handleOpen(item.id),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_regular_svg_icons_index_es/* faChevronUp */.mTx
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_regular_svg_icons_index_es/* faChevronDown */.ptq
                                })
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Post_module_default()).AccordionContent,
                        dangerouslySetInnerHTML: {
                            __html: item.content
                        }
                    })
                ]
            }, item.title);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/TabSection-1dc1cccf.js
var TabSection_1dc1cccf = __webpack_require__(3167);
;// CONCATENATED MODULE: ./src/components/routes/Tabs/Tabs.tsx







var tabProgressEventSent = false;
var tabIntroductionEventSent = false;
var Tabs = function() {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var slug = router.query.slug;
    var onClickTab = function(tab) {
        if (tabIntroductionEventSent && tab === "introduction") return;
        if (tabProgressEventSent && tab === "progress") return;
        index_097a0a02.q.send({
            event: "route_tab_click",
            route_name: slug,
            tab_name: tab
        });
        if (tab === "progress") tabProgressEventSent = true;
        if (tab === "introduction") tabIntroductionEventSent = true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabSection_1dc1cccf.S, {
        customClass: "Tabs",
        defaultTab: "progress",
        handleClickOnTab: onClickTab,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabSection_1dc1cccf.T, {
                title: t("route.tabs.routeCourses"),
                shouldShow: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {})
            }, "progress"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabSection_1dc1cccf.T, {
                title: t("route.tabs.about"),
                shouldShow: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post, {})
            }, "introduction")
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/routes/SelectPlan/SelectPlan.tsx





var SelectPlan = function() {
    var t = useTranslation().t;
    var isLogged = useSelector(function(state) {
        return state.get("header");
    }).get("isLogged") || false;
    var user = useSelector(function(state) {
        var ref, ref1;
        return (ref1 = (ref = state.get("header")) === null || ref === void 0 ? void 0 : ref.get("userInfo")) === null || ref1 === void 0 ? void 0 : ref1.get("userType");
    }) || "free";
    if (isLogged || user !== "free") return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.SelectPlan,
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: t("route.selectPlan.choosePlanText")
            }),
            /*#__PURE__*/ _jsx("a", {
                href: "#planes",
                children: t("route.selectPlan.choosePlanAction")
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@platzi/ui/dist/es/BasicTooltip-bac55ec4.js
var BasicTooltip_bac55ec4 = __webpack_require__(56);
// EXTERNAL MODULE: ./src/components/routes/AddRouteButton/AddRouteButton.module.sass
var AddRouteButton_module = __webpack_require__(9137);
var AddRouteButton_module_default = /*#__PURE__*/__webpack_require__.n(AddRouteButton_module);
;// CONCATENATED MODULE: ./src/components/routes/AddRouteButton/AddRouteButton.tsx











var AddRouteButton = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var routeId = (0,es/* useSelector */.v9)(function(state) {
        return state.get("route").get("id");
    }) || 0;
    var ref = (0,react.useState)(false), isTooltipActive = ref[0], setIsTooltipActive = ref[1];
    (0,react.useEffect)(function() {
        (0,api/* getFollowSchools */.CS)().then(function(res) {
            var ref;
            var isFollowing = (ref = res.data) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                return item.learningPathId === routeId;
            });
            if (isFollowing.length > 0) {
                props.setUserFollowSchool(true);
            } else {
                props.setUserFollowSchool(false);
            }
        }).catch(function(err) {
            throw new Error("::ERROR::GET_ROUTES_ADD-ROUTE-BUTTON", {
                cause: err
            });
        });
    }, []);
    var handleFollow = function() {
        props.setUserFollowSchool(true);
        (0,api/* followSchool */.iC)(routeId, {
            level: "basic"
        }).then(function() {
            return index_097a0a02.q.send((0,_object_spread/* default */.Z)({}, props.recordFollowRoute));
        }).catch(function(err) {
            throw new Error("::ERROR::FOLLOW_ROUTES_ADD-ROUTE-BUTTON", {
                cause: err
            });
        });
    };
    var handleTooltipInteraction = function() {
        setIsTooltipActive(!isTooltipActive);
    };
    if (props.userFollowSchool === undefined) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (AddRouteButton_module_default()).Empty
        });
    }
    if (props.userFollowSchool) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AddRouteButton_module_default()).ButtonAddedCont,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (AddRouteButton_module_default()).Added,
                    onClick: function() {
                        return props.setShowModal(true);
                    },
                    onMouseEnter: handleTooltipInteraction,
                    onMouseLeave: handleTooltipInteraction,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_regular_svg_icons_index_es/* faCircleCheck */.fV7
                        }),
                        t("route.addRouteButton.added")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicTooltip_bac55ec4.B, {
                    isActive: isTooltipActive,
                    position: "top",
                    styles: {
                        width: "100%"
                    },
                    children: t("route.addRouteButton.unfollowRoute")
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        type: "button",
        onClick: handleFollow,
        className: (AddRouteButton_module_default()).AddRouteButton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: pro_regular_svg_icons_index_es/* faCirclePlus */.EQ8
            }),
            t("route.addRouteButton.add")
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/routes/index.ts












;// CONCATENATED MODULE: ./src/pages/ruta/[slug].tsx



var AddPredictor = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {});
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (AddPredictor);


/***/ }),

/***/ 6394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ schoolsApi; }
});

;// CONCATENATED MODULE: ./src/services/api/schoolsApi.ts
var schoolsApi = {
    server: {
        header: "/api/bff/org/optimized-header/",
        explore: "/api/v5/header-explorer/",
        school: function(slug) {
            return "/api/v5/school/".concat(slug, "/");
        },
        community: function(slug) {
            return "/api/v5/school/".concat(slug, "/community_info/");
        },
        identity: "/api/v5/users/identity/",
        route: function(slug) {
            return "/api/v5/learning-path/".concat(slug, "/");
        },
        contactInfo: "/api/bff/web/contact-info/"
    },
    client: {
        schools: {
            getFollowSchools: "/api/v4/user-learning-paths/",
            followSchool: function(schoolId) {
                return "/api/v4/user-learning-paths/".concat(schoolId, "/assign/");
            },
            unFollowSchool: function(schoolId) {
                return "/api/v4/user-learning-paths/".concat(schoolId, "/");
            },
            challenges: function(ids) {
                return "/api/v1/info/?related_learning_path_ids=".concat(ids);
            },
            placement_test: function(schoolSlug) {
                return "/api/v5/school/".concat(schoolSlug, "/placement_test/");
            },
            routesProgress: function(schoolSlug) {
                return "/api/v5/school/".concat(schoolSlug, "school_progress/");
            }
        },
        routes: {
            routeProgress: function(id) {
                return "/api/v5/learning-path/".concat(id, "/progress/");
            }
        },
        registerEmail: "/webhookemail/hola/",
        userPlans: "/api/v4/landing/plans/?hide=b2b_plan",
        tablePrice: "/plans/v1/table-price/",
        b2bPlans: "/api/v4/b2b/landing/plans/"
    }
};

;// CONCATENATED MODULE: ./src/services/api/index.ts



/***/ }),

/***/ 9137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Empty":"AddRouteButton_Empty__cwHCR","AddRouteButton":"AddRouteButton_AddRouteButton__GOi7d","Added":"AddRouteButton_Added__a7kCv","ButtonAddedCont":"AddRouteButton_ButtonAddedCont__IRdC3","Tooltip":"AddRouteButton_Tooltip__rlvyj"};

/***/ }),

/***/ 2705:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Aside":"Aside_Aside__5iGeU","Content":"Aside_Content__e6a1y","Thumbnail":"Aside_Thumbnail__0H8KX","Title":"Aside_Title__wSWbO","ClassContent":"Aside_ClassContent__sNeJ1","ClassTitle":"Aside_ClassTitle__Ew5_K","Course":"Aside_Course__Tpc_A","RouteContent":"Aside_RouteContent__T9d9v","TeachersContent":"Aside_TeachersContent__yEcxj","TeachersHeaderModal":"Aside_TeachersHeaderModal__jzv3y","TeachersContentModal":"Aside_TeachersContentModal__BtsU7","TeachersHeaderModalClose":"Aside_TeachersHeaderModalClose__SwbSp","TeachersContentHeader":"Aside_TeachersContentHeader__ZMoIs","ShowMore":"Aside_ShowMore__LgDGp","ShowMoreAccordion":"Aside_ShowMoreAccordion__8CXYO"};

/***/ }),

/***/ 1258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Actions":"Actions_Actions__wkMH1","ShareCta":"Actions_ShareCta__HuVXI","StartCta":"Actions_StartCta__jcxBU"};

/***/ }),

/***/ 7494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AdminButton":"AdminButton_AdminButton__x3G7k"};

/***/ }),

/***/ 4265:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__groM_","Title":"Header_Title__VxhX0","BuyButton":"Header_BuyButton__r1AzW"};

/***/ }),

/***/ 620:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Card":"ModalUnfollow_Card__40jMj","CardHeader":"ModalUnfollow_CardHeader__3Nv2V","CardBody":"ModalUnfollow_CardBody__UVFh7","CardFooter":"ModalUnfollow_CardFooter__0HJ4A","CancelButton":"ModalUnfollow_CancelButton___30lh","CloseModal":"ModalUnfollow_CloseModal__ixZ7i"};

/***/ }),

/***/ 8303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__muc8k","Columns":"Layout_Columns___FSbE"};

/***/ }),

/***/ 2011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__hKyCO","Accordion":"Post_Accordion__5gX_E","AccordionContent":"Post_AccordionContent__qEnf3"};

/***/ }),

/***/ 278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Course":"Course_Course__bLjGn","CourseInformation":"Course_CourseInformation__53jA_","CourseProgressCont":"Course_CourseProgressCont__cZcFy"};

/***/ }),

/***/ 2034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TitleContainer":"Module_TitleContainer__8mR86","Title":"Module_Title__JyRK5","LevelContainer":"Module_LevelContainer__f6Csc","LevelName":"Module_LevelName__pkYa2"};

/***/ }),

/***/ 3471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Steps":"Steps_Steps__1I6KO","Title":"Steps_Title__A0vSF"};

/***/ }),

/***/ 5795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PricingTable":"PricingTable_PricingTable__E_j8O","u-wrapper":"PricingTable_u-wrapper___6Hwv"};

/***/ }),

/***/ 5853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Button":"ShareButton_Button__MY_Um"};

/***/ }),

/***/ 7601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Card":"ShareModal_Card__rLkVi","CloseModal":"ShareModal_CloseModal__J_QIj","Input":"ShareModal_Input__RMeqj","whatsapp":"ShareModal_whatsapp__8X5JP","twitter":"ShareModal_twitter__StxBu","telegram":"ShareModal_telegram__Jhw_w","facebook":"ShareModal_facebook__N9jUp","linkedin":"ShareModal_linkedin__3n41N"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,385,348,112,151,885,286,774,888,179], function() { return __webpack_exec__(1151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);